<template>
  <v-form ref="form">
    <v-card outlined>
      <v-card-text>
        <MarkdownEditor :label="$t('userFeedbackForm.feedback.label')" v-model="formData.feedback" @change="save" />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="save" :loading="loading" small>
          {{ $t("userFeedbackForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import UpdateUserFeedbackMinimalRequirementMutation from "@/gql/mutations/UpdateUserFeedbackMinimalRequirementMutation.gql";
import MarkdownEditor from "@/components/Common/MarkdownEditor.vue";

export default {
  components: {
    MarkdownEditor,
  },

  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        feedback: this.requirement.userFeedback,
      },
      loading: false,
      saved: false,
    };
  },

  methods: {
    async save() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: UpdateUserFeedbackMinimalRequirementMutation,
        variables: {
          id: this.requirement._id, // _id because report is generated as json
          feedback: this.formData.feedback,
        },
      });

      this.loading = false;
      this.saved = true;
    },
  },
};
</script>
